import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';

@RegisterItem()
export class CNDisease extends CNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNDisease';
    }

    public clone(): any {
        return new CNDisease();
    }
}

